import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { getCurrentDate } from "../utils/formatTime";
import { getStoredValue } from "../_helpers/storagehelper";

const loggedUser = getStoredValue("user")?.ManagementUserID;
const facilityID = getStoredValue("commonFacilityCode");
const initialNoticeData = {
  NoticeID: 0,
  FacilityID: 0,
  NoticeTitle: "",
  NoticeDispaly: "",
  StartDate: "",
  EndDate: "",
  ActiveStatus: 1,
  Action: 1,
  NoticePermissionList: [],
  IsExistingNotice: 0,
  error: null,
  loading: false,
  createdBy: 0,
};

const initialSearchData = {
  facilityID: 0,
  kiosksID: 0,
  startDate: "",
  endDate: "",
  activeStatus: 2,
  pageNo: 1,
  rowCountPerPage: 10,
  sortBy: "",
};

const exportNotice = {
  fromFacilityID: facilityID,
  createdBy: loggedUser,
  isSucceed: 0,
  noticeToFacilityList: [],
};

const replicateNotice = {
  noticeID: 0,
  replicateStartDate: "",
  replicateEndDate: "",
  createdBy: loggedUser,
  isSucceed: 0,
  noticeReplicateFacilityList: [],
};
// create slice
const name = "notice";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports
export const noticeAction = { ...slice.actions, ...extraActions };
export const noticeReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    noticeSearchdata : initialSearchData,
    noticeData: initialNoticeData,
    noticeListResponse: {},
    KIOSKDropDownResponse: [],
    addOrUpdateNoticeResponse: {},
    deleteResponse: {},
    facilityListForExportNotice: {},
    exportNoticeData: exportNotice,
    submitExportNoticeResponse: {},
    replicateNoticeData: replicateNotice,
    replicateNoticeResponse: {},
  };
}

function createReducers() {
  return {
    setNoticeData,
    setExportNoticeData,
    setReplicateNotice,
    updateExportData,
    clearDeleteResponse,
    updateKIOSKList,
    resetForm,
    resetResponse,
    setNoticeSearch,
    resetNoticeSearch,
    clearResponse,
    clearExportNoticeDataResponse,
  };

  function clearResponse(state) {
    state.replicateNoticeData = {
        noticeID: 0,
        replicateStartDate: "",
        replicateEndDate: "",
        createdBy: loggedUser,
        isSucceed: 0,
        noticeReplicateFacilityList: []
    };
}

  function setNoticeSearch(state, action) {
    state.noticeSearchdata = action && action.payload;
  }

  function resetNoticeSearch(state) {
    state.noticeSearchdata = initialSearchData;
  }

  function setNoticeData(state, action) {
    state.noticeData = action.payload && action.payload;
  }

  function setExportNoticeData(state, action) {
    state.exportNoticeData = action.payload && action.payload;
  }

  function setReplicateNotice(state, action) {
    state.replicateNoticeData = action.payload && action.payload;
  }

  function clearDeleteResponse(state, action) {
    state.deleteResponse = {};
  }

  function updateExportData(state, action) {
    state.facilityListForExportNotice.DataList =
      action.payload && action.payload;
  }

  function updateKIOSKList(state, action) {
    state.KIOSKDropDownResponse = action.payload && action.payload;
  }

  function resetForm(state, action) {
    state.noticeData = initialNoticeData;
    state.exportNoticeData = exportNotice;
    // state.addOrUpdateNoticeResponse = 3;
  }

  function resetResponse(state, action) {
    state.addOrUpdateNoticeResponse = 3;
    state.replicateNoticeResponse = 3
  }
  
  function clearExportNoticeDataResponse(state) {
    state.submitExportNoticeResponse = null;
    state.replicateNoticeResponse = null;
  }

}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser`;
  return {
    noticeList: noticeList(),
    KIOSKDropDown: KIOSKDropDown(),
    addOrUpdateNotice: addOrUpdateNotice(),
    getNoticeDetails: getNoticeDetails(),
    deleteNotice: deleteNotice(),
    exportNotices: exportNotices(),
    submitExportNotice: submitExportNotice(),
    replicateNotices: replicateNotices(),
  };

  function noticeList() {
    return createAsyncThunk(
      `${name}/noticeList`,
      async (data) =>
        await fetchWrapper.post(`${baseUrl}/Notice/LoadNoticeList`, data)
    );
  }
  //kiosk drop down
  function KIOSKDropDown() {
    const URL = `${process.env.REACT_APP_API_URL}`;
    return createAsyncThunk(
      `${name}/LoadKioskDropDown`,
      async (facilityID) =>
        await fetchWrapper.get(
          `${URL}/Common/LoadKioskDropDown?podID=0&facilityID=${facilityID}&activeStatus=2`
        )
    );
  }

  //addOrUpdateNotice
  function addOrUpdateNotice() {
    return createAsyncThunk(
      `${name}/addOrUpdateNotice`,
      async (data) =>
        await fetchWrapper.post(`${baseUrl}/Notice/NoticeInsertUpdate`, data)
    );
  }

  //notice specific details
  function getNoticeDetails() {
    return createAsyncThunk(
      `${name}/getNoticeDetails`,
      async (noticeID) =>
        await fetchWrapper.get(
          `${baseUrl}/Notice/LoadNoticeDetails?noticeId=${noticeID}`
        )
    );
  }

  //delete notice
  function deleteNotice() {
    return createAsyncThunk(
      `${name}/deleteNotice`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/Notice/NoticeDelete?noticeId=${data?.noticeID}&createdBy=${data?.createdBy}`
        )
    );
  }

  //export notice
  function exportNotices() {
    return createAsyncThunk(
      `${name}/exportNotices`,
      async (facilityID) =>
        await fetchWrapper.get(
          `${baseUrl}/Notice/LoadNoticesFacilityDropDown?FacilityID=${facilityID}`
        )
    );
  }

  //submit Expor Notice
  function submitExportNotice() {
    return createAsyncThunk(
      `${name}/submitExportNotice`,
      async (data) =>
        await fetchWrapper.post(`${baseUrl}/Notice/ExportNotices`, data)
    );
  }

  //submit Expor Notice
  function replicateNotices() {
    return createAsyncThunk(
      `${name}/replicateNotices`,
      async (data) =>
        await fetchWrapper.post(`${baseUrl}/Notice/ReplicateNotices`, data)
    );
  }
}

function createExtraReducers(builder) {
  builder
    //notice list
    .addCase(extraActions.noticeList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.noticeList.fulfilled, (state, action) => {
      const params = action.meta.arg;
      if (params?.exportExcel) {
        state.noticeListResponseFullData = action?.payload;
      } else {
        state.noticeListResponse = action.payload;
      }
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.noticeList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to add notice";
    })

    //KIOSK
    .addCase(extraActions.KIOSKDropDown.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.KIOSKDropDown.fulfilled, (state, action) => {
      state.KIOSKDropDownResponse = action?.payload;
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.KIOSKDropDown.rejected, (state, action) => {
      state.error = action.error.message || "Failed to Edit facility";
      state.loading = false;
    })

    //add or edit notice
    .addCase(extraActions.addOrUpdateNotice.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.addOrUpdateNotice.fulfilled, (state, action) => {
      state.addOrUpdateNoticeResponse = action?.payload;
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.addOrUpdateNotice.rejected, (state, action) => {
      state.error = action.error.message || "Failed to Add Or Edit Notice";
      state.loading = false;
    })
    //get specific notice details
    .addCase(extraActions.getNoticeDetails.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getNoticeDetails.fulfilled, (state, action) => {
      state.noticeData = action?.payload;
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.getNoticeDetails.rejected, (state, action) => {
      state.error = action.error.message || "Failed to Edit Notice";
      state.loading = false;
    })

    //delete notice
    .addCase(extraActions.deleteNotice.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.deleteNotice.fulfilled, (state, action) => {
      state.deleteResponse = action?.payload;
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.deleteNotice.rejected, (state, action) => {
      state.error = action.error.message || "Failed to Delete Notice";
      state.loading = false;
    })

    //facility list for export notice
    .addCase(extraActions.exportNotices.pending, (state) => {
      state.facilityListForExportNotice.loading = true;
      state.error = null;
    })
    .addCase(extraActions.exportNotices.fulfilled, (state, action) => {
      state.facilityListForExportNotice = action?.payload;
      state.facilityListForExportNotice.loading = false;
      state.error = null;
    })
    .addCase(extraActions.exportNotices.rejected, (state, action) => {
      state.error = action.error.message || "Failed to get facility list";
      state.facilityListForExportNotice.loading = false;
    })

    //submit export notice
    .addCase(extraActions.submitExportNotice.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.submitExportNotice.fulfilled, (state, action) => {
      state.submitExportNoticeResponse = action?.payload;
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.submitExportNotice.rejected, (state, action) => {
      state.error = action.error.message || "Failed to submit export notice";
      state.loading = false;
    })

    //replicate notice
    .addCase(extraActions.replicateNotices.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.replicateNotices.fulfilled, (state, action) => {
      state.replicateNoticeResponse = action?.payload;
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.replicateNotices.rejected, (state, action) => {
      state.error = action.error.message || "Failed to submit export notice";
      state.loading = false;
    });
}
